import React from 'react';

import PropTypes from "prop-types";

import {Layout} from "../../Layout/Layout";

import './error.css';

const ErrorPage = (props) => {

   let message;
   switch(props.code) {
      case 400:
         message = "Can not process request.";
         break;
      case 401:
      case 403:
         message = "Sorry, you do not have permission to view this.";
         break;
      case 404:
         message = "We could not find the requested resource.";
         break;
      case 500:
      default:
         message = "Looks like an error occurred.";
         break;
   }

   if (props.description && props.description !== '') message = props.description;

   return [<Layout.Content key={'contentContainer'} padContent={false}>

      <a href="/app/portal" id="embedded-return-arrow">
         <i className={"fa fa-arrow-left fa-3x text-primary"}></i>
         <span> Return
            <br/> to portal </span>
      </a>
      <div className={"center-block mt50 mw800"}>
         <h1 className={"embedded-error-title"}> {props.code}! </h1>

         <h2 className={"embedded-error-subtitle"}>{message}</h2>
      </div>

   </Layout.Content>
      ,
      <div className={"pull-right"} key={'footer'}>
         <img src="https://cdn.hydroscloud.com/hydros-web/images/logos/hydros_grey_semitrans.svg"
              className={"img-responsive mt20 w150 mr15"}
              alt="logo"/>
      </div>
   ]
};

ErrorPage.propTypes = {
   code: PropTypes.number,
   description: PropTypes.string,
};

ErrorPage.defaultProps = {
   code: 500,
   description: null,
};

export default ErrorPage;
